module.exports = __webpack_public_path__ + "img/culqi-lg.25de8583.png";